import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link } from 'react-router-dom';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function UpdateProduct({ username, onClose, onProductID, getProduct }) {
    const [loading, setLoading] = useState(false);
    const [metalList, setMetalList] = useState([]);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    const [totalPrice, setTotalPrice] = useState(0);

    const [formData, setFormData] = useState({
        id: onProductID,
        name: "",
        matt_id: "",
        price: "",
        tax: "",
        comment: "",
        est_id: "",
        user_transaction: username,
        color: "",
    });

    //Handle form changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    //Fetch product data
    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await axios.get(`${server_backend}/Products/select?id=${onProductID}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        name: data.name,
                        comment: data.comment,
                        user_transaction: username,
                        id: onProductID,
                        est_id: data.est_ID,
                        matt_id: data.matt_ID,
                        purity: data.purity,
                        unit: data.unit,
                        price: data.price,
                        reference: data.reference,
                        color: data.color
                    });
                }
            } catch (error) {
                console.error("Error fetching product data", error);
            }
        };
        fetchProduct();
    }, [onProductID, username]);

    //Fetch metal types
    useEffect(() => {
        const fetchMetalList = async () => {
            try {
                const response = await axios.get(`${server_backend}/Products/types/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMetalList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.error("Error fetching metal types", error);
            }
        };
        fetchMetalList();
    }, []);

    //Update product data
    const handleUpdate = async (e) => {
        e.preventDefault();
        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/Products/update`, formData, headers);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        getProduct();
                        onClose();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Product already exists, please try another name',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);
                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            }
        })
    };

    //Calculate the total price with tax every time the price or tax
    useEffect(() => {
        const price = parseFloat(formData.price) || 0;
        const tax = parseFloat(formData.tax) || 0;
        const total = price + (price * (tax / 100));
        setTotalPrice(total.toFixed(2)); //rounded two decimals
    }, [formData.price, formData.tax]);


    return (
        <div className="container-fluid">
            <div className="row">
                <div className="card">
                    <div className="card-header align-items-center d-flex">
                        <div className="col-md-12 text-end">
                            <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Alert',
                                    text: "Are you sure you want to discard these changes?",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept',
                                    cancelButtonText: "Cancel"
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        onClose();
                                    }
                                }
                                )
                            }
                            }>Discard Change</Link>
                            <button className="btn btn-primary" type="submit" onClick={handleUpdate} disabled={loading}>
                                {loading ? "Loading..." : "Update"}
                            </button>
                        </div>
                    </div>

                    <div className="card-header text-center">
                        <h4>Update Product</h4>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleUpdate}>
                            <div className="row">
                                {/*Name */}
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Product Name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/*Price */}
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="price" className="form-label">Price</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Price"
                                        name="price"
                                        value={formData.price}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/*Tax */}
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="tax" className="form-label">Tax (%)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Tax Percentage"
                                        name="tax"
                                        value={formData.tax}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/*Total Price (Price + Tax) */}
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="totalPrice" className="form-label">Total Price (incl. Tax)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="totalPrice"
                                        value={totalPrice}
                                        disabled
                                    />
                                </div>

                                {/*Comment */}
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="comment" className="form-label">Comment</label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter Comment"
                                        name="comment"
                                        value={formData.comment}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>

                                {/*Status */}
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="est_id" className="form-label">Status</label>
                                    <select
                                        className="form-select"
                                        name="est_id"
                                        value={formData.est_id}
                                        onChange={handleChange}
                                    >
                                        <option value="1">Activated</option>
                                        <option value="2">Disabled</option>
                                    </select>
                                </div>

                                <h4 className="p-3">Other Information</h4>

                                <div className="col-6 mb-3">
                                    <label htmlFor="date_created" className="form-label">Date Created</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={vAdminformat.FormatDate(dateCreated)}
                                        disabled
                                    />
                                </div>

                                <div className="col-6 mb-3">
                                    <label htmlFor="user_created" className="form-label">User Created</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={userCreated}
                                        disabled
                                    />
                                </div>

                                <div className="col-6 mb-3">
                                    <label htmlFor="date_modify" className="form-label">Date Modified</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={dateModify && vAdminformat.FormatDate(dateModify)}
                                        disabled
                                    />
                                </div>

                                <div className="col-6 mb-3">
                                    <label htmlFor="user_modify" className="form-label">User Modified</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={userModify}
                                        disabled
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="card-header align-items-center d-flex">
                        <div className="col-md-12 text-end">
                            <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Alert',
                                    text: "Are you sure you want to discard these changes?",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept',
                                    cancelButtonText: "Cancel"
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        onClose();
                                    }
                                }
                                )
                            }
                            }>Discard Change</Link>
                            <button className="btn btn-primary" type="submit" onClick={handleUpdate} disabled={loading}>
                                {loading ? "Loading..." : "Update"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateProduct;
